import Axios from '../baseApi';

export default {
  async addOrUpdate(values) {
    return await Axios.post(`/api-master-data/v1/number-range`, values);
  },
  async fetchById(id) {
    return await Axios.get(`/api-master-data/v1/number-range/${id}`);
  },
  async getNext(id) {
    return await Axios.get(`/api-master-data/v1/number-range/next/${id}`);
  }
}
